import React, { Suspense } from 'react'
import { AppsLoader } from './AppsLoader'

export const App = props => {
    return (
      <Suspense fallback={<></>}>
        <AppsLoader {...props}/>
      </Suspense>
    )
}